import { useEffect, useState } from "react"

export function useDebouncedValue<T>(value: T, delayMs: number): T {
	const [debouncedValue, setDebouncedValue] = useState(value)

	useEffect(() => {
		const timeoutId = window.setTimeout(() => {
			setDebouncedValue(value)
		}, delayMs)

		return () => {
			window.clearTimeout(timeoutId)
		}
	}, [value, delayMs])

	return debouncedValue
}
